<!--
 * @Author: guoyu
 * @Date: 2020-05-08 14:54:43
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2023-08-24 11:03:11
 * @Description: 支付的渠道选择
 -->
<template>
  <div class="pay-type">
    <h3 class="type-title">支付渠道</h3>
    <general-checkbox
      v-model="checkThreeParty"
      :options="threePartyPaymentOptionList"
      :col="isPc ? 4 : 2"
      :rowStyle="isPc ? { 'justify-content': 'flex-start' } : ''"
      @change="selectThreeParty"
    >
      <template v-slot="{ item, checked }">
        <div class="check-item" :class="{ checked }">
          <img
            :src="item.imageUrl"
            :class="item.className"
            alt=""
            v-if="item.value != 'balance'"
          />
          <span v-if="item.value === 'balance'">{{ item.label }}</span>
          <p class="user-balance" v-if="item.value === 'balance'">
            <span>{{ userBalance }}幣 可用</span>
          </p>
        </div>
      </template>
    </general-checkbox>
    <!-- <div>nicee幣支付</div>
    <div @click="selectThreeParty(threePartyPaymentOption.lanXin)">藍新</div>
    <div @click="selectThreeParty(threePartyPaymentOption.funPoint)">
      funPoint
    </div> -->
    <div class="card-type">
      <h3
        class="type-title"
        v-show="checkThreeParty != threePartyPaymentOption.balance"
      >
        付款方式
      </h3>
      <general-checkbox
        v-model="checkVal"
        :options="payList"
        :disabled="isDisabled"
        :class="{ 'is-from-new': isDisabled }"
        :col="isPc ? 4 : 2"
        :rowStyle="isPc ? { 'justify-content': 'flex-start' } : ''"
        @changeItem="getCheckedInfo"
      >
        <template v-slot="{ item, checked }">
          <div class="check-item" :class="{ checked }">
            <span>{{ item.label }}</span>
          </div>
        </template>
      </general-checkbox>
    </div>
  </div>
</template>
<script>
import GeneralCheckbox from '@/components/common/checkbox/general-checkbox';
export default {
  name: 'PayType',
  components: {
    'general-checkbox': GeneralCheckbox
  },
  model: {
    event: 'change',
    prop: 'payType'
  },
  props: {
    payType: { type: String, default: 'Balance' }, // 支付类型
    userBalance: { type: Number, default: 0 }, // 用户余额
    price: { type: Number, default: 0 }, // 应付金额
    isPc: { type: Boolean, default: true }, // 是否是pc
    isFromNew: { type: Boolean, default: true }
  },
  data() {
    return {
      //第三方支付類型
      threePartyPaymentOption: {
        balance: 'balance',
        lanXin: 'lanXin',
        fomoPay: 'fomoPay',
        payPal: 'payPal',
        funPoint: 'funPoint',
        tapPay: 'tapPay',
        stripe: 'stripe'
      },
      checkThreeParty: 'balance', //已選金流支付類型
      // 餘額支付類型
      balanceOption: {
        code: 'Balance',
        val: '1',
        validity: 'ExpireDate',
        label: 'nicee餘額支付',
        value: 'Balance',
        time: this.validTime
      }
    };
  },
  computed: {
    checkVal: {
      get() {
        return this.payType;
      },
      set(newVal) {
        this.$emit('change', newVal);
      }
    },
    validTime() {
      // 三方支付的时间显示
      return this.getValidTime();
    },
    isDisabled() {
      return this.isFromNew || !!this.$route.query.quickMatchUuid;
    },
    // 是否极速约单
    isQuickMatch() {
      return !!this.$route.query.quickMatchUuid;
    },
    payList() {
      let payOptions = [];
      if (this.checkThreeParty === this.threePartyPaymentOption.lanXin) {
        payOptions = [
          {
            code: 'VACC',
            val: '1',
            validity: 'ExpireDate',
            label: '銀行轉帳',
            value: 'LanXinATM',
            time: this.validTime
          },
          // {
          //   code: 'CREDIT',
          //   val: '1',
          //   label: '信用卡',
          //   validity: 'TradeLimit',
          //   value: 'LanXinCreditCard',
          //   time: 900
          // }
        ];
        if (this.price > 30 && this.price < 2000) {
          payOptions.push({
            code: 'CVS',
            val: '1',
            label: '超商代碼繳費',
            validity: 'ExpireDate',
            value: 'LanXinSupermarket',
            time: this.validTime
          });
        }
      } else {
        if (this.checkThreeParty === this.threePartyPaymentOption.payPal) {
          payOptions = [
            {
              code: 'CREDIT',
              val: '1',
              label: '信用卡/金融卡',
              validity: 'TradeLimit',
              value: 'PayPal_CheckOut',
              time: 900
            }
          ];
        }
        if (this.checkThreeParty === this.threePartyPaymentOption.fomoPay) {
          payOptions = [
            {
              code: 'CREDIT',
              val: '1',
              label: '信用卡/金融卡',
              validity: 'TradeLimit',
              value: 'FOMO_WX_WEB',
              time: 900
            }
          ];
        }
        if (this.checkThreeParty === this.threePartyPaymentOption.funPoint) {
          payOptions = [
            {
              code: 'ALL',
              val: '1',
              label: '信用卡/ATM/...',
              value: 'FUN_POINT'
            }
          ];
        }
        if (this.checkThreeParty === this.threePartyPaymentOption.tapPay) {
          payOptions = [
            {
              code: 'CREDIT',
              val: '1',
              label: '信用卡/金融卡',
              validity: 'TradeLimit',
              value: 'TAB_PAY_CARD',
              time: 900
            }
          ];
        }
        if (this.checkThreeParty === this.threePartyPaymentOption.stripe) {
          payOptions = [
            {
              code: 'CREDIT',
              val: '1',
              label: '信用卡/金融卡',
              value: 'StripeCheckOut',
              time: 900
            }
          ];
        }
      }
      return payOptions;
    },
    threePartyPaymentOptionList() {
      return this.isQuickMatch
        ? [
            {
              label: '餘額支付',
              value: this.threePartyPaymentOption.balance
            }
          ]
        : [
            {
              label: '餘額支付',
              value: this.threePartyPaymentOption.balance
            },
            {
              label: 'tappay',
              value: this.threePartyPaymentOption.tapPay,
              imageUrl: require('./images/tapPay.png'),
              className: 'tappay'
            },
            {
              label: 'stripe',
              value: this.threePartyPaymentOption.stripe,
              imageUrl: require('./images/stripe.png'),
              className: 'tappay'
            },
            {
              label: 'paypal',
              value: this.threePartyPaymentOption.payPal,
              imageUrl: require('./images/paypal.png'),
              className: 'paypal'
            },
            // {
            //   label: 'funPoint',
            //   value: this.threePartyPaymentOption.funPoint,
            //   imageUrl: require('./images/funPoint.png'),
            //   className: 'funPoint'
            // },
            {
              label: '藍新支付',
              value: this.threePartyPaymentOption.lanXin,
              imageUrl: require('./images/spgateway.png'),
              className: 'lanxin'
            },
            {
              label: 'fomopay',
              value: this.threePartyPaymentOption.fomoPay,
              imageUrl: require('./images/weChatPay.png'),
              className: 'weChat'
            },
          ];
    }
    // payList() {
    //   let payOptions = [
    //     // 选项list

    //     // {
    //     //   code: 'Balance',
    //     //   val: '1',
    //     //   validity: 'ExpireDate',
    //     //   label: 'nicee幣支付',
    //     //   value: 'Balance',
    //     //   time: this.validTime
    //     // },
    //     // {
    //     //   code: 'ALL',
    //     //   val: '1',
    //     //   label: '信用卡/ATM/...',
    //     //   value: 'LINE_FUN_POINT'
    //     // },
    //     {
    //       code: 'VACC',
    //       val: '1',
    //       validity: 'ExpireDate',
    //       label: '銀行轉帳',
    //       value: 'LanXinATM',
    //       time: this.validTime
    //     },
    //     {
    //       code: 'CREDIT',
    //       val: '1',
    //       label: '信用卡',
    //       validity: 'TradeLimit',
    //       value: 'LanXinCreditCard',
    //       time: 900
    //     }
    //   ];
    //   if (this.$route.query.quickMatchUuid) {
    //     return [payOptions[0]];
    //   }
    //   if (this.price > 30 && this.price < 2000) {
    //     payOptions.push({
    //       code: 'CVS',
    //       val: '1',
    //       label: '超商代碼繳費',
    //       validity: 'ExpireDate',
    //       value: 'LanXinSupermarket',
    //       time: this.validTime
    //     });
    //   }
    //   return payOptions;
    // }
  },
  methods: {
    /**
     * @description: 返回当前选中完整信息
     */
    getCheckedInfo(item) {
      this.$emit('change', item.value);
      this.$emit('changeItem', item);
    },
    getValidTime() {
      let cur = new Date();
      let validDate = new Date(cur.getTime() + 48 * 60 * 60 * 1000);
      let monthper = validDate.getMonth() > 8 ? '' : '0';
      let month = validDate.getMonth() + 1;
      let monthString = monthper + month.toString();
      let datePer = validDate.getDate() > 9 ? '' : '0';
      let dateString = datePer + validDate.getDate().toString();
      let validTime =
        validDate.getFullYear().toString() + monthString + dateString;
      return validTime;
    },
    /**
     * @description: 获取某支付方式的信息
     */
    filterItem(payType) {
      return this.payList.filter(item => {
        return item.value === payType;
      })[0];
    },
    // 選擇支付金流
    selectThreeParty(threeParty) {
      this.checkThreeParty = threeParty;
      localStorage.setItem('threePartyPayment', threeParty);
      if (threeParty === this.threePartyPaymentOption.balance) {
        this.getCheckedInfo(this.balanceOption);
      } else {
        this.getCheckedInfo(this.payList[0]);
      }
    }
  },
  created() {
    // 返回默认的选中项
    this.$emit('changeItem', this.filterItem(this.payType));
  }
};
</script>
<style lang="scss" scoped>
.pay-type {
  padding: 20px 18px 11px;
  font-size: 18px;
  color: #333333;
  display: flex;
  flex-wrap: wrap;
}
.lanxin {
  width: 108px;
}
.funPoint {
  width: 81px;
}
.tappay {
  width: 108px;
}
.paypal {
  width: 81px;
}
.weChat {
  width: 122px;
}
.card-type {
  display: flex;
  margin-top: 30px;
}
.type-title {
  line-height: 1;
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: 600;
  margin-right: 34px;
}
.check-item {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 162px;
  height: 56px;
  overflow: hidden;
  border: 1px solid #dddddd;
  margin-bottom: 14px;
  border-radius: 4px;
  font-size: 14px;
}
.checked {
  border: 1px solid $color-orange;
  &::after {
    content: '';
    display: block;
    position: absolute;
    top: -1px;
    right: -1px;
    height: 15px;
    width: 15px;
    background-color: $color-orange;
    border-radius: 0 0 0 4px;
    background-image: url('~@/assets/imgs/white-check.png');
    background-repeat: no-repeat;
    background-size: 8px 6px;
    background-position: center center;
  }
}
.user-balance {
  margin-top: 6px;
  font-size: 12px;
  color: #999999;
}
.player-coin {
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-right: 4px;
  background: url('~@/assets/imgs/player-coin.png') no-repeat center;
  background-size: 100% 100%;
  vertical-align: bottom;
}
.is-from-new {
  opacity: 0.3;
}
@media screen and (min-width: 600px) {
  .pay-type {
    padding: 30px 0px 30px;
  }
  .check-item {
    // margin-bottom: 0;
    margin-right: 20px;
  }
}
@media screen and (max-width: 360px) {
  .check-item {
    width: 152px;
    height: 51px;
  }
}
@media screen and (max-width: 320px) {
  .check-item {
    width: 136px;
    height: 41px;
  }
}
</style>
